import { c as _c } from "react/compiler-runtime";
import { Outlet } from 'react-router';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';

/*
 * This layout is just for the main app wrapper
 *
 *
 */
export const Main = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      flexGrow: 1
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Box sx={t0}><Grid container={true} spacing={0} sx={{}}><Outlet /></Grid></Box>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};